"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var helper_1 = require("../../utils/helper");
var context_1 = require("../Dropdown/context");
var context_2 = require("./context");
var theme_1 = require("../../utils/theme");
var focus_1 = require("../../utils/focus");
var Menu = (function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listRef = React.createRef();
        _this.clickedIds = [];
        _this.selectedItemDoms = new Set();
        _this.handleClick = function (e) {
            if (_this.clickedIds.length === 0) {
                return;
            }
            var id = _this.clickedIds.shift();
            _this.clickedIds = [];
            _this.props.onClick(id, e);
            _this.context.onClick();
        };
        _this.handleItemClick = function (id) {
            _this.clickedIds.push(id);
        };
        _this.handleContextMenu = function (e) {
            e.preventDefault();
        };
        _this.handleKeyDown = function (e) {
            if (!_this.isVisible()) {
                return;
            }
            var container = _this.listRef.current;
            if (e.key === 'ArrowDown') {
                focus_1.traverseFocusIn(container, e, false);
            }
            else if (e.key === 'ArrowUp') {
                focus_1.traverseFocusIn(container, e, true);
            }
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, itemStyle = _b.itemStyle, selectedIds = _b.selectedIds, type = _b.type, itemClassName = _b.itemClassName, selectable = _b.selectable, subMenuViewportMargin = _b.subMenuViewportMargin, testId = _b.testId, onClick = _b.onClick, visible = _b.visible, keyDownEventDom = _b.keyDownEventDom, rest = tslib_1.__rest(_b, ["prefixCls", "className", "style", "children", "itemStyle", "selectedIds", "type", "itemClassName", "selectable", "subMenuViewportMargin", "testId", "onClick", "visible", "keyDownEventDom"]);
            var selfVisible = _this.isVisible();
            var cls = classNames(prefixCls, prefixCls + "-" + type, className, (_a = {},
                _a[prefixCls + "-hidden"] = !selfVisible,
                _a[prefixCls + "-non-selectable"] = !selectable,
                _a));
            return (h(context_1.DropdownContext.Consumer, null, function (_a) {
                var dropdownVisible = _a.visible;
                return (h(context_2.MenuItemContext.Provider, { value: context_2.getMenuItemContext({
                        itemStyle: itemStyle,
                        itemClassName: itemClassName,
                        clickHandler: _this.handleItemClick,
                        selectedIds: selectedIds,
                        selectedItemDoms: _this.selectedItemDoms,
                    }) },
                    h(context_2.SubMenuContext.Provider, { value: context_2.getSubMenuContext({
                            zIndex: 10000,
                            visible: dropdownVisible && selfVisible,
                            type: type,
                            horizontalPlacement: 'right',
                            viewportMargin: subMenuViewportMargin,
                        }) },
                        h("ul", tslib_1.__assign({ className: cls, style: style, onClick: _this.handleClick, onContextMenu: _this.handleContextMenu, role: "menu", "aria-haspopup": true, ref: _this.listRef, "data-testid": testId }, rest), children))));
            }));
        };
        return _this;
    }
    Object.defineProperty(Menu.prototype, "keyDownDom", {
        get: function () {
            return this.props.keyDownEventDom === undefined ? document : this.props.keyDownEventDom;
        },
        enumerable: false,
        configurable: true
    });
    Menu.prototype.isVisible = function () {
        return this.context.visible && this.props.visible;
    };
    Menu.prototype.scrollToSelected = function () {
        var _a;
        var selectedDoms = Array.from(this.selectedItemDoms.values());
        (_a = selectedDoms[0]) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    };
    Menu.prototype.componentDidMount = function () {
        var _a;
        this.forceUpdate();
        (_a = this.keyDownDom) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', this.handleKeyDown);
    };
    Menu.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.keyDownDom) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', this.handleKeyDown);
    };
    Menu.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    Menu.contextType = context_2.ContextMenuContext;
    return Menu;
}(React.Component));
exports.default = Menu;
Menu.defaultProps = {
    prefixCls: 'dui-menu',
    onClick: helper_1.emptyFn,
    selectedIds: [],
    visible: true,
    type: 'normal',
    selectable: true,
    subMenuViewportMargin: 2,
};
